import components from "./components";

export const chartsGenerator = (routes) =>
  routes.map((route) => ({
    ...route,
    Component: components[route.type],
  }));
